<template>
  <div class="changeAmount">
    <el-dialog title="变更量明细" :visible.sync="changeAmountVisible" width="90%" :show-close="true">
      <div class="content flex-column h-100">
        <div class="flex mb-10">
          <div class="btn-24-bg-ff flex align-center mr-5 button" @click="onAdd">
            <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
            添加
          </div>
          <div class="btn-24-bg-ff flex align-center mr-5 button" @click="onSave">
            <img src="/static/images/customer/baocun.png" class="icon-14 mr-5" alt="">
            保存
          </div>
        </div>
        <div class="flex-1 h-0">
          <erp-table ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData"></erp-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ErpTable from '../../../components/ErpTable'
export default {
  name: 'ChangeAmount',
  components: {ErpTable},
  props: [],
  data () {
    return {
      changeAmountVisible: false,
      loading: true,
      tableData: [],
      columnData: [{
        field: 'name',
        title: '变更时间',
        width: '300'
      }, {
        field: 'name',
        title: '项目名称',
        width: '300'
      }, {
        field: 'name',
        title: '结算量计算式',
        width: '300'
      }, {
        field: 'name',
        title: '结算量'
      }]
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    onAdd () {},
    onSave () {}
  }
}
</script>

<style lang="scss" scoped>
  .content{
    padding: 10px 20px;
  }
  .changeAmount /deep/ .el-dialog{
    height: 80%;
    display: flex;
    flex-direction: column;
  }
  .changeAmount /deep/ .el-dialog__body{
    flex: 1;
  }
  .button{
    border: solid 1px #e2e2e2;
    border-radius: 4px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/enterRoomItem/changeAmount.vue